// External dependencies
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Routes
import { Checkout } from 'features/onlinePayment';

const Root = () => (
  <Switch>
    <Route path="/agendar-consulta" component={Checkout} />
    <Redirect to="/404/" />
  </Switch>
);

export default Root;
